import { DateBox } from 'devextreme-react';
import moment from 'moment';
import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { khoanNopGroupApi } from '../../../../api/khoanNopGroupApi';
import { saleSetDichVuApi } from '../../../../api/saleSetRegisterDichVu';
import { Button } from "../../../../components/buttons";
import ComboMaHSFilter from "../../../../components/combo-maHS-filter";
import { ComboboxNamHoc } from '../../../../components/combobox-namhoc';
import { FormGroup } from '../../../../components/form-group';
import { AnimationPopup } from '../../../../components/modal';
import TagBoxDanhSachDichVu from '../../../../components/tagbox-danh-sach-dich-vu';
import { getDefaultAnimation } from '../../../../helpers/pop-up-animation';
import { showNotify } from '../../../../helpers/toast';
import { sf_khoannop_group } from '../../../../models/response/category/sf_khoannop_group';
import { ts_hocsinh_viewmodel } from '../../../../models/response/hocsinh/ts_hocsinh';
import { sf_saleset_register_dichvu, sf_saleset_register_dichvu_viewmodel } from "../../../../models/response/sale-set-dichvu/sf_saleset_register_dichvu";
import { RootState } from '../../../../state/reducers';
import ComboBoxDanhSachDichVu from '../../../../components/combobox-dichvu';

type Props = {
    title?: string,
    onClose: () => void;
    onSubmit: (data: sf_saleset_register_dichvu_viewmodel) => void,
    sf_saleset_register_dichvu_editting?: sf_saleset_register_dichvu_viewmodel,
    is_saving?: boolean,
    animationOf: string,
    ts_hocsinh?: ts_hocsinh_viewmodel,

}
const trang_thai_dang_kys = [
    { id: 0, name: "Chưa đăng ký" },
    { id: 1, name: "Đã đăng ký" },
    { id: 2, name: "Chờ hủy" },
    { id: 3, name: "Đã hủy" }
];
const DangKyDichVuHocSinhModal = (props: Props) => {
    console.log(props.sf_saleset_register_dichvu_editting)
    const { nam_hoc, dm_coso_id } = useSelector((x: RootState) => x.common);
    const [sf_khoannop_groups, set_sf_khoannop_groups] = useState<sf_khoannop_group[]>([])
    const [khoanNopFilter, setKhoanNopFilter] = useState<number[]>([]);

    const [formData, setFormData] = useState<sf_saleset_register_dichvu_viewmodel>(
        !props.sf_saleset_register_dichvu_editting ||
            (Array.isArray(props.sf_saleset_register_dichvu_editting) && props.sf_saleset_register_dichvu_editting.length === 0)
            ? {
                id: 0,
                nam_hoc: nam_hoc,
                dm_truong_id: 0,
                ts_hocsinh_id: 0,
                sf_khoannop_group_id: 0,
                sf_saleset_register_dichvu_status_id: 1,
                tu_ngay: moment().format("YYYY-MM-DDTHH:mm:ss"),
                den_ngay: '',
                is_active: true,
                ma_hs: '',
                ho_ten: '',
                ma_khoan_nop_group: '',
                ten_khoan_nop_group: '',
                ten_lop: '',
                trang_thai: '',
                trang_thai_dich_vu: '',
                dm_khoi_id: 0,
                dm_he_id: 0,
                dm_lop_id: 0,
                ngay_sinh: '',
                sf_saleset_register_type_id: 0
            }
            : props.sf_saleset_register_dichvu_editting
    );

    useEffect(() => {
        if (props.ts_hocsinh) {
            setFormData({
                ...formData, ts_hocsinh_id: props.ts_hocsinh.id, ho_ten: props.ts_hocsinh.ho_ten, ma_hs: props.ts_hocsinh.ma_hs, ten_lop: props.ts_hocsinh.ten_lop, dm_khoi_id: props.ts_hocsinh.dm_khoi_id, dm_he_id: props.ts_hocsinh.dm_he_id, dm_truong_id: props.ts_hocsinh.dm_truong_id
            })
        }
    }, [props.ts_hocsinh])
    useEffect(() => {
        handleReloadKhoanNopGroups();
    }, [])
    const handleReloadKhoanNopGroups = async () => {
        const res = await khoanNopGroupApi.select_all();
        if (res.is_success) {
            set_sf_khoannop_groups(res.data.filter((x: any) => x.dm_coso_id == dm_coso_id && (x.is_dichvu || x.is_dichvu_fixed)))
        }
    };
    const animaition = getDefaultAnimation({ of: props.animationOf });

    const onSubmit = async (event: React.FormEvent) => {
        event.preventDefault();
        if (formData.id > 0) {
            props.onSubmit(formData);
        }
        else {
            const datasend: sf_saleset_register_dichvu = {
                id: formData.id,
                ts_hocsinh_id: formData.ts_hocsinh_id,
                nam_hoc: formData.nam_hoc || nam_hoc,
                sf_khoannop_group_id: formData.sf_khoannop_group_id || 0,
                sf_saleset_register_dichvu_status_id: formData.sf_saleset_register_dichvu_status_id || 1,
                is_active: formData.is_active || true,
                tu_ngay: formData.tu_ngay || moment().format("YYYY-MM-DDTHH:mm:ss"),
                den_ngay: formData.den_ngay || '',
                sf_saleset_register_type_id: formData.sf_saleset_register_type_id
            }
            if (datasend.ts_hocsinh_id === 0) {
                showNotify({
                    message: `Vui lòng chọn học sinh`,
                    type: "warning"
                })
                return;
            }
            if (khoanNopFilter.length === 0) {
                showNotify({
                    message: `Vui lòng chọn dịch vụ đăng ký`,
                    type: "warning"
                })
                return;
            }
            if (datasend.tu_ngay === '') {
                showNotify({
                    message: `Vui lòng chọn ngày bắt đầu đăng ký`,
                    type: "warning"
                })
                return;
            }
            // if (datasend.den_ngay === '') {
            //     showNotify({
            //         message: `Vui lòng chọn ngày kết thúc đăng ký`,
            //         type: "warning"
            //     })
            //     return;
            // }
            const res = await saleSetDichVuApi.Inserts({ sf_saleset_register_dichvu: datasend, sf_khoannop_group_ids: khoanNopFilter });
            if (res.is_success) {
                props.onClose()
                showNotify({
                    message: `Cập nhật thành công`,
                    type: "success"
                })
            }
            else {
                showNotify({
                    message: `Có lỗi`,
                    type: "warning"
                })
            }
        }
    };

    const onClose = useCallback(() => {
        window.animationHidePopup(props.animationOf || "")
        setTimeout(() => {
            props.onClose();
        }, 500);
    }, [props.animationOf])

    return (
        <AnimationPopup
            animationOf={'#btnInsert'}
            title={props.title}
            width='xlarge'
            onClose={onClose}
        >
            <form onSubmit={onSubmit}>
                <div className="pop-up-form">
                    <div className="row">
                        <div className="col-md-6">
                            <FormGroup label='Mã học sinh'></FormGroup>
                            <ComboMaHSFilter
                                defaultValue={{ ma_hs: formData.ma_hs, ts_hocsinh_hoten: formData.ho_ten }}
                                onResultChanged={(value) => {
                                    setFormData({ ...formData, ma_hs: value.ts_hocsinh.ma_hs, ho_ten: value.ts_hocsinh.ho_ten, ts_hocsinh_id: value.ts_hocsinh.id });
                                }}

                            />
                        </div>
                        <div className="col-md-6">
                            <FormGroup label='Năm học'></FormGroup>
                            <ComboboxNamHoc
                                width='290'
                                value={formData.nam_hoc || nam_hoc}
                                onValueChanged={(value) => {
                                    setFormData({ ...formData, nam_hoc: value || '' });
                                }}
                            />

                        </div>
                        <div className="col-md-12 padding-top-1rem">
                            <FormGroup label='Dịch vụ'></FormGroup>
                            <ComboBoxDanhSachDichVu
                                isReadonly={formData.id > 0}
                                isShowClearButton={true}
                                value={formData.sf_khoannop_group_id}
                                onValueChanged={(value) => {
                                    setFormData({ ...formData, sf_khoannop_group_id: value });
                                }}
                            />

                        </div>
                        {/* <div className="col-md-12 padding-top-1rem">
                            <FormGroup label='Loại dịch vụ'></FormGroup>
                            <TagBoxDanhSachDichVu
                                isShowClearButton={true}
                                dataSource={sf_khoannop_groups}
                                value={khoanNopFilter}
                                onValueChanged={(value) => {
                                    setKhoanNopFilter(value === null ? [] : value);
                                }}
                                isdichvu={true}

                            />
                        </div> */}
                        <div className="col-md-6 padding-top-1rem">
                            <FormGroup label='Từ ngày'></FormGroup>
                            <DateBox
                                stylingMode="outlined"
                                value={formData.tu_ngay}
                                displayFormat={'dd-MM-yyyy'}

                                dateSerializationFormat={'yyyy-MM-ddTHH:mm:ss'}
                                useMaskBehavior={true}
                                onValueChanged={(e: any) => {
                                    setFormData({ ...formData, tu_ngay: e.value });
                                }}
                            />

                        </div>
                        <div className="col-md-6 padding-top-1rem">
                            <FormGroup label='Đến ngày'></FormGroup>
                            <DateBox
                                stylingMode="outlined"
                                value={formData.den_ngay}
                                displayFormat={'dd-MM-yyyy'}
                                dateSerializationFormat={'yyyy-MM-ddTHH:mm:ss'}
                                useMaskBehavior={true}
                                onValueChanged={(e: any) => {
                                    setFormData({ ...formData, den_ngay: e.value });
                                }}
                            />

                        </div>
                        {/* <div className="col-md-12 padding-top-1rem">
                            <FormGroup label='Trạng thái đăng ký'>
                            </FormGroup>
                            <SelectBox
                             dataSource={trang_thai_dang_kys}
                                displayExpr="name"
                                valueExpr="id"
                                value={formData.sf_saleset_register_dichvu_status_id}
                                stylingMode="outlined"
                                onValueChanged={(e) => {
                                    setFormData({ ...formData, sf_saleset_register_dichvu_status_id: e.value });
                                }} />
                        </div> */}
                    </div>

                </div>
                <div className="pop-up-actions">
                    <Button type="normal" icon="fa fa-times" text="Đóng" onClick={onClose}></Button>{' '}
                    <Button type="normal" icon="fas fa-check-square" isLoading={props.is_saving || false} text={formData.id !== undefined && formData.id > 0 ? "Cập nhật" : "Thêm mới"} isSubmitButton={true} onClick={() => onSubmit}></Button>
                </div>
            </form>
        </AnimationPopup>
    );
};
export default DangKyDichVuHocSinhModal